import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { config } from '../../config';

// Assets
// import logo from '../../assets/icon-star.png'
import logo from '../../assets/icon-black-green.png'
// import logoFull from '../../assets/logo-full.png'
import logoFull from '../../assets/logo-full-rebrand.png'

// Redux
import { attemptLogout } from '../../redux/Auth/auth.actions'
import { FullUI } from '../../redux/UI/ui.selectors'
import { FullNetwork } from '../../redux/Network/network.selectors'
import { FullAccount, ThisAccount } from '../../redux/Account/account.selectors';
import { toggleDrawer } from '../../redux/UI/ui.actions'
import { Role, NetworkRole } from '../../redux/Auth/auth.selectors'

import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router'

// Material UI

import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';


// Material Icons
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import SwapCallsIcon from '@mui/icons-material/SwapCalls';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';

// Styled Material UI
import { StyledList, StyledListItem, StyledListItemText, StyledListItemIcon } from '../../styles/matieralui/List';
import { StyledMenu } from '../../styles/matieralui/Menus';
import { SmartContainer, Stack } from '../../styles/Containers'

// TCC Components
import { Theme, setSpace, respondTo, jsRespondTo } from '../../styles/Theme'
import { Logo } from './Logo';
import { TopLevelNavigation } from '../../capturecollab/components/Dashboard/TopLevelNavigation';
import { IconSettings, IconTeam } from '../../capturecollab/Icons';
import { MobileTrigger } from './MobileTrigger';
import { StyledB, StyledP } from '../../styles/StyledHTML';
import { Link } from 'react-router-dom';
import { ImageCroppingPresets, MediaImage } from '../../modules/Media/MediaUtils';
import { AccountSwitcher } from '../Account/AccountSwitcher';
import { StyledDivider } from '../../styles/matieralui/Divider';


// Styled Components
const StyledMainNav = styled.div`
    [data-main-nav-wrap]{
        height: 100vh;
        
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        /* padding: ${setSpace(2)} ${setSpace(2)}; */
        /* padding-top: ${setSpace(6)}; */
       
        
        background-color: ${Theme.colors.baseAlternate};
        box-shadow: ${Theme.shadow.one};
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        

        // Capture Collab
        /* overflow:auto; */
        width: auto;
        max-width: 200px;
        ${props => (!props.open) ? css`width:66px;` : 'width:200px;'}
        border-right: ${Theme.borderWidth} solid currentColor;
        [data-logo-container]{ margin-bottom: 0em !important; padding-top: 15px; 
            ${props => (!props.open) ? css` padding-bottom: 11px;` : ''}
           
        
        }
        [data-nav-top] {
            
            flex: 1;
            overflow: auto;
            
        }
        [data-bottom-nav]{

            /* flex: 5; */
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
        }
    }
    
    .logo-account-name {
        text-align: center;
    }
    

    ${respondTo('mobile', css`
        
        [data-main-nav-wrap]{
            ${props => (!props.open) ? css` display: none;` : ' display: flex;'}
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            overflow: scroll;
            z-index: 100;
            box-shadow: 0px 10px 20px -10px rgba(0,0,0,0.25);
            justify-content: flex-start;
            max-width: none;

            [data-bottom-nav]{
                /* border-top: 1px solid rgba(0,0,0,0.05); */
                margin-top: 0.5em;
                padding-top: 0.5em;
            }
            [data-folders-wrap] { display: none; }
        }
        [data-toggle-trigger] { display: none; }
        [data-full-logo] {
            display: none !important;
        }
        [data-logo-container]{}
        .logo-icon {
            margin-bottom: 1em;
            display: block;
            position: absolute;
            left: 0.75em;
            top: -4.5em;
            /* display: none !important; */
        }
        .logo-account-name {
            /* text-align: left; */
            padding-left: 1em;
            font-weight: bold;
            opacity: 1;
        }
        [data-nav-top]{
            padding: 1em 0.5em;

        }
    `)}

`
const MobileClose = styled(SmartContainer)`
    display: none !important;
    /* margin-top: -1em; */
    transform: translate(-10px,-10px);
    ${respondTo('mobile', css`display: flex !important;`)}
`

const MobileMenuButton = styled(IconButton)`
    /* position: fixed !important;
    bottom: ${setSpace(2)};
    left: ${setSpace(2)};
    background-color: ${Theme.colors.baseAlternate} !important;
    display: none !important;
    z-index: 101;
    box-shadow: 0px 4px 8px -4px rgba(0,0,0,0.25);
    ${respondTo('mobile', css`
        display:inline-flex !important;
    `)} */
`

const StyledNavText = styled(StyledListItemText)`
    .MuiTypography-root {
        font-size: 0.9rem !important;
    }
`

const StyledItem = styled(StyledListItem)`
    .MuiTypography-root {
        font-size: 0.75em !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .MuiSvgIcon-root {
        width: 0.75em;
        height: 0.75em;
    }
`
/**
 * Nav Item
 */

export const NavItem = ({ text, open, icon, to, onClick, tooltip }) => {

    return (
        <Tooltip title={tooltip} placement="right">
            <StyledItem button onClick={(e) => onClick(to, e)}>
                <StyledListItemIcon>{icon}</StyledListItemIcon>
                {open && (<StyledNavText primary={text} />)}
            </StyledItem>
        </Tooltip>
    )
}

/**
 * The Main Navigation
 */

export const MainNav = (props) => {

    // Read From State
    const dispatch = useDispatch();
    const currentUserRole = Role();
    const fullNetwork = FullNetwork();
    const thisAccount = ThisAccount();

    const currentNetworkRole = NetworkRole(fullNetwork.network?.id);
    const ui = FullUI();
    const open = (!ui.drawer) ? false : ui.drawer.open;
    const isMobile = (!ui?.drawer?.isMobile) ? false : ui.drawer.isMobile;
    const [openMobile, setOpenMobile] = useState(false)

    const handleSelect = (to, e) => dispatch(push(to));
    const handleLogout = () => dispatch(attemptLogout());
    const toggleOpen = () => {
        dispatch(toggleDrawer(!open, isMobile))
    }

    // My Account Menu 
    const goTo = (path) => dispatch(push(path))
    const [anchorEl, setAnchorEl] = useState(null);
    const handleAccountClick = (event) => {
        dispatch(push('/settings'))
        // setAnchorEl(event.currentTarget); // Opens Modal
        if (isMobile === true) dispatch(toggleDrawer(false, true))
    }

    const handleTeamClick = (event) => {
        dispatch(push('/team'))
        // setAnchorEl(event.currentTarget); // Opens Modal
        if (isMobile === true) dispatch(toggleDrawer(false, true))
    }

    const handleAccountClose = (action) => {

        if (action == 'logout') dispatch(attemptLogout());
        if (action == 'account') dispatch(push('/account'));
        setAnchorEl(null)
    }

    const handleMobileOpen = (e) => {

        if (open === true) {
            setOpenMobile(false);
            dispatch(toggleDrawer(false, true))
        } else {
            setOpenMobile(true);
            dispatch(toggleDrawer(true, true))
        }
    }

    const renderPageNavigation = () => {
        if (props.pageNavigation) return props.pageNavigation();
    }

    const logoSrc = (!open) ? logo : logoFull;

    useEffect(() => {
        // Nav Mount
        // If this isn't mobile set to open.
        const isMobile = jsRespondTo('mobile');
        if (!isMobile && !ui.drawer) dispatch(toggleDrawer(true, isMobile))
    }, [])



    return (
        <StyledMainNav open={open}>

            <SmartContainer data-main-nav-wrap>
                <Stack width="100%" data-nav-top>

                    <MobileClose flex align="center" justify="flex-end"><MobileTrigger /></MobileClose>

                    <Stack data-logo-container position="relative" width="100%">
                        <SmartContainer width="100%">
                            {!thisAccount?.meta?.icon && (<Logo data-logo-icon src={logo} className="logo-icon" />)}
                            {thisAccount?.meta?.icon && (
                                <SmartContainer flex align="center" justify="center" data-logo-icon className="logo-icon">
                                    <Link to="/">
                                        <MediaImage radius id={thisAccount?.meta?.icon} crop={ImageCroppingPresets.thumbnail} style={{ maxWidth: '50px', marginLeft: 'auto', marginRight: 'auto' }} />
                                    </Link>
                                </SmartContainer>
                            )}

                            {open && (<img data-full-logo src={logoFull} style={{ width: '76%', height: 'auto', marginLeft: '12%', marginTop: '1em' }} />)}
                            {/*open && (<StyledP light className="logo-account-name">{thisAccount?.name}</StyledP>)*/}
                            {open && (<AccountSwitcher />)}
                        </SmartContainer>
                    </Stack>

                    <SmartContainer data-nav-body>{renderPageNavigation()}</SmartContainer>

                    {/* <StyledList>
                    <NavItem onClick={handleSelect} tooltip="Home" open={open} text="Home" to="/" icon={<HomeOutlinedIcon />} />
                    <NavItem onClick={handleSelect} tooltip="Example Content" open={open} text="Example Content" to="/examplecontent" icon={<HomeOutlinedIcon />} />
                    <NavItem onClick={handleSelect} tooltip="Placeholder" open={open} text="Placeholder" to="/" icon={<HomeOutlinedIcon />} />
                    {currentUserRole === 'administrator' && (<NavItem onClick={handleSelect} tooltip="Add Ons" open={open} text="Add Ons" to="/dashboard/addons" icon={<StorefrontOutlinedIcon />} />)}
                </StyledList> */}

                    {!props.pageNavigation && (<SmartContainer data-nav-body><TopLevelNavigation /></SmartContainer>)}
                </Stack>

                <SmartContainer data-bottom-nav width="100%">

                    <StyledDivider />
                    <br />
                    {/* {open && (<StyledP small light>&nbsp;&nbsp;<StyledB>Settings</StyledB></StyledP>)} */}
                    <StyledList width="100%">
                        {config.allowTeammates === true && (currentUserRole === 'owner' || currentUserRole === 'admin') && (
                            <Tooltip title="Manage Your Team" placement="right" width="100%">
                                <StyledItem button onClick={handleTeamClick}>
                                    <StyledListItemIcon><IconTeam /></StyledListItemIcon>
                                    {open && (<StyledNavText primary="Team" />)}
                                </StyledItem>
                            </Tooltip>
                        )}
                        <Tooltip title="Manage Your Account" placement="right">
                            <StyledItem button onClick={handleAccountClick}>
                                <StyledListItemIcon><IconSettings /></StyledListItemIcon>
                                {open && (<StyledNavText primary="Settings" />)}
                            </StyledItem>
                        </Tooltip>
                        <Tooltip title="Open Nav" placement="right" data-toggle-trigger>
                            <StyledItem button onClick={toggleOpen}>
                                <StyledListItemIcon>
                                    {!open && (<KeyboardArrowRightOutlinedIcon />)}
                                    {open && (<CloseOutlinedIcon />)}
                                </StyledListItemIcon>
                                {open && (<StyledNavText primary="Close" />)}
                            </StyledItem>
                        </Tooltip>
                    </StyledList>
                </SmartContainer>

                <StyledMenu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleAccountClose}
                >
                    <StyledList>
                        <NavItem onClick={handleSelect} tooltip="Manage Your Profile" open={true} text="My Profile" to="/profile" icon={<AccountCircleOutlinedIcon />} />
                        {currentUserRole === 'owner' && (<NavItem onClick={handleSelect} tooltip="Manage Your Subscription" open={true} text="Billing" to="/billing" icon={<CreditCardIcon />} />)}
                        {config.allowTeammates === true && (currentUserRole === 'owner' || currentUserRole === 'admin') && (<NavItem onClick={handleSelect} tooltip="Manage Your Team" open={true} text="Team" to="/team" icon={<PeopleOutlinedIcon />} />)}
                        {config.allowMultipleAccounts === true && (<NavItem onClick={handleSelect} tooltip="Switch Accounts" open={true} text="Switch Accounts" to="/accounts" icon={<SwapCallsIcon />} />)}
                        {currentUserRole === 'owner' && (<NavItem onClick={handleSelect} tooltip="Account Settings" open={true} text="Settings" to="/settings" icon={<SettingsOutlinedIcon />} />)}
                        {currentNetworkRole && currentNetworkRole !== 'norole' && (<NavItem onClick={handleSelect} tooltip="Network Settings" open={true} text="Network" to="/network" icon={<LanguageOutlinedIcon />} />)}
                        <NavItem onClick={handleLogout} tooltip="Signout of Your Account" open={true} text="Log Out" to="/logout" icon={<ExitToAppOutlinedIcon />} />
                    </StyledList>

                </StyledMenu>

            </SmartContainer>

            {/*<MobileMenuButton onClick={handleMobileOpen}>
                {!open && (<MenuIcon />)}
                {open && (<CloseOutlinedIcon />)}
                    </MobileMenuButton>*/}

        </StyledMainNav >
    )
}